import Navbar from "./Navbar";
import Footer from "./Footer";

export default function StaticPage({ title, subtitle, updated, children }) {
  return (
    <div style={{ minHeight: "100vh", background: "#fff" }}>
      <Navbar />
      <main className="gd-page" style={{ padding: "64px 24px 48px", maxWidth: 760 }}>
        <div style={{ marginBottom: 32 }}>
          <h1
            style={{
              fontSize: 44,
              fontWeight: 700,
              letterSpacing: "-0.03em",
              lineHeight: 1.1,
              margin: 0,
              marginBottom: 12,
            }}
            data-testid="page-title"
          >
            {title}
          </h1>
          {subtitle && (
            <p style={{ color: "var(--text-muted)", fontSize: 17, lineHeight: 1.55, margin: 0 }}>
              {subtitle}
            </p>
          )}
          {updated && (
            <p style={{ color: "var(--text-subtle)", fontSize: 13, margin: "14px 0 0" }}>
              Last updated: {updated}
            </p>
          )}
        </div>

        <article className="gd-prose">{children}</article>
      </main>
      <Footer />
    </div>
  );
}
